'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List, is } from 'immutable';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import * as CampaignReportingData from 'AdsUI/data/CampaignReportingData';
import { EntityTypes, AttributionViews } from 'AdsUI/lib/Constants';
import { updateCampaign, updateAdGroup, updateAd, updateKeyword } from 'AdsUI/data/EntityManagementData';
import FBBreakdownFunnelRecord from 'AdsUI/records/analyze/FBBreakdownFunnelRecord';
import { listConstruct, construct } from 'AdsUI/lib/Transform';
import { getRequestData } from 'AdsUI/lib/CampaignManagementItemTypes';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import { fromGlobalFilters } from 'AdsUI/records/reporting/CampaignListFilterRecord';
const updateEntityMap = {
  [EntityTypes.CAMPAIGN]: updateCampaign,
  // { accountId, id, network, status }
  [EntityTypes.ADGROUP]: updateAdGroup,
  // { accountId, campaignId, id, network, status }
  [EntityTypes.AD]: updateAd,
  // { accountId, adGroupId, campaignId, id, network, status }
  [EntityTypes.KEYWORD]: updateKeyword // { accountId, adId, adGroupId, campaignId, id, network, status }

};
export const fetchCampaignDetails = (network, accountId, campaignId, timeRange, attributionView = AttributionViews.FIRST_FORM_SUBMISSION) => {
  return dispatch => {
    wrapReduxAction(CampaignReportingData.fetchCampaignDetails.bind(null, network, accountId, campaignId, timeRange, attributionView), 'CAMPAIGN_DETAILS_FETCH', {
      allParams: {
        filters: {
          timeRange,
          network,
          entityId: campaignId,
          attributionView
        }
      },
      dispatch
    });
  };
};
export const fetchChildrenByEntity = (network, accountId, campaignId, entityType, entityId, timeRange, attributionView, statuses) => {
  return dispatch => {
    wrapReduxAction(CampaignReportingData.fetchChildrenByEntity.bind(null, network, accountId, campaignId, entityType, entityId, timeRange, attributionView, statuses), 'CHILDREN_BY_ENTITY_FETCH', {
      allParams: {
        filters: {
          timeRange,
          attributionView,
          campaignId,
          network,
          entityId,
          entityType,
          statuses
        }
      },
      dispatch,
      transform: response => response.reports ? {
        response
      } : {
        response: {
          reports: response
        }
      }
    });
  };
};
export const updateReportingEntity = (network, adAccount, entity, entityType, campaignId, parent, update, returnPromise = false) => {
  const networkUpdate = getRequestData(network, entity, update);
  const opts = {
    campaignId: entityType === EntityTypes.CAMPAIGN && entity.id || campaignId,
    id: entity.id,
    adGroupId: entityType === EntityTypes.ADGROUP && entity.id || entityType !== EntityTypes.CAMPAIGN && parent.id,
    accountId: adAccount.accountId,
    update: networkUpdate,
    network
  };
  return (dispatch, getState) => {
    const state = getState();
    const globalFilters = getGlobalFilters(state);
    const activeFilter = fromGlobalFilters(globalFilters);

    if (entityType === EntityTypes.CAMPAIGN) {
      const {
        campaignList
      } = state;
      const keysToInvalidate = campaignList.keySeq().filter(key => !is(key, activeFilter));
      keysToInvalidate.forEach(key => dispatch({
        type: Actions.CAMPAIGN_LIST_STATE_INVALIDATE,
        payload: {
          filters: key
        }
      }));
    }

    const apiCall = updateEntityMap[entityType];
    return wrapReduxAction(apiCall.bind(null, opts), 'CAMPAIGN_REPORTING_ENTITY_UPDATE', {
      allParams: {
        parent,
        network,
        entityType,
        entityId: entity.id,
        update,
        globalFilters,
        adAccount
      },
      dispatch,
      returnPromise
    });
  };
};
export const updateReportingEntityStatus = (network, adAccount, entity, entityType, campaignId, parent, status) => updateReportingEntity(network, adAccount, entity, entityType, campaignId, parent, {
  status
});
export const updateSequenceCampaignStatus = (network, adAccount, campaign, sequenceId, sequenceStep, status) => {
  const networkUpdate = getRequestData(network, campaign, {
    status
  });
  const opts = {
    id: campaign.id,
    accountId: adAccount.accountId,
    update: networkUpdate,
    network
  };
  return (dispatch, getState) => {
    const state = getState();
    const globalFilters = getGlobalFilters(state);
    const activeFilter = fromGlobalFilters(globalFilters);
    const {
      campaignList
    } = state;
    const keysToInvalidate = campaignList.keySeq().filter(key => !is(key, activeFilter));
    keysToInvalidate.forEach(key => dispatch({
      type: Actions.CAMPAIGN_LIST_STATE_INVALIDATE,
      payload: {
        filters: key
      }
    }));
    const apiCall = updateEntityMap[EntityTypes.CAMPAIGN];
    return wrapReduxAction(apiCall.bind(null, opts), 'SEQUENCE_CAMPAIGN_STATUS_UPDATE', {
      allParams: {
        network,
        entityId: campaign.id,
        update: {
          status
        },
        sequenceId,
        sequenceStep,
        globalFilters,
        adAccount
      },
      dispatch,
      returnPromise: true
    });
  };
};
export const fetchCampaignBreakdowns = (accountId, campaignId, timeRange) => {
  return dispatch => {
    return wrapReduxAction(CampaignReportingData.fetchCampaignBreakdowns.bind(null, accountId, campaignId, timeRange), 'FB_BREAKDOWN_FUNNELS_FETCH', {
      dispatch,
      allParams: {
        campaignId
      },
      transform: resp => {
        return {
          funnels: listConstruct(List, construct(FBBreakdownFunnelRecord))(resp)
        };
      }
    });
  };
};
export const fetchAdSequenceDetails = (sequenceId, timeRange, attributionView = AttributionViews.FIRST_FORM_SUBMISSION) => {
  return dispatch => {
    wrapReduxAction(CampaignReportingData.fetchAdSequence.bind(null, sequenceId, timeRange, attributionView), 'SEQUENCE_DETAILS_FETCH', {
      allParams: {
        filters: {
          timeRange,
          sequenceId,
          attributionView
        }
      },
      dispatch
    });
  };
};
export const fetchPublishedAdSequence = sequenceId => dispatch => {
  return wrapReduxAction(CampaignReportingData.fetchAdSequence.bind(null, sequenceId), 'PUBLISHED_SEQUENCE_DETAILS_FETCH', {
    returnPromise: true,
    dispatch
  });
};